import React from "react";
import { usePrivacyStyles } from "./Privacy.styles";

export const PrivacyHe: React.FC = () => {
  const classes = usePrivacyStyles();

  return (
    <div className={classes.root} dir="rtl">
      <h1 className={classes.mainHeader}>מדיניות פרטיות</h1>
      <div className={classes.subMainHeader}>עודכן לאחרונה: 12 בדצמבר 2024</div>

      <ol className={classes.list}>
        <li className={classes.content}>
          פעילת החברה מכבדת את פרטיותך ואת פרטיות המשתמשים בו. מטרת התנאים
          המפורטים במדיניות פרטיות זו, המהווים חלק בלתי נפרד מתנאי השימוש באתר
          ונועדה להסביר את האופן שבו משתמשת מפעילת האתר ו/או החברה במידע שנמסר
          לה על ידך באתר ו/או נאסף על ידה בעת השימוש אתר, ועל מדיניות השמירה על
          פרטיות המשתמשים באתר על פי הדין.
        </li>

        <li className={classes.content}>
          מפעילת האתר ו/או החברה רשאיות לשנות מעת לעת את הוראות מדיניות הפרטיות
          שלהן, כדי שישקפו שינויים טכנולוגיים, עסקיים, משפטיים או רגולטורים.
          במקרה שכזה, השינוי יעודכן ויפורסם באתר. שימושך באתר לאחר ביצוע
          השינויים, יעיד על הסכמתך לשינויים אלו, ועל כן אנו ממליצים לעיין
          במדיניות זו מעת לעת.
        </li>

        <li className={classes.content}>
          בעצם הכניסה, הגישה והשימוש של המשתמש באתר ו/או בשירותים, המשתמש מביע
          את הסכמתו לאיסוף המידע, לעיבודו ולשמירתו במאגרי המידע של מפעילת האתר,
          החברה, בעלת השליטה במאגר, שדרכי ההתקשרות עמה מצויים במדיניות פרטיות
          זו.
        </li>

        <li className={classes.content}>
          המשתמש מסכים ומצהיר בזאת שהמידע שהוא מספק לחברה נמסר בהסכמתו ומרצונו
          החופשי, על מנת שהחברה תספק עבורו את השירותים ובהתאם למטרות המפורטות
          במדיניות פרטיות זו. יובהר כי ללא הסכמת המשתמש למסירת מידע כאמור, החברה
          עשויה שלא לספק למשתמש את השירותים, חלקם או כולם. אם אינך מסכים לתנאי
          מדיניות פרטיות זו, אינך מורשה להשתמש באתר ו/או בשירותים.
        </li>

        <li className={classes.content}>
          <b>העברת מידע לחברה </b>- למפעילת האתר ו/או החברה מאגר מידע בו ישמרו
          פרטיך, כמפורט במדיניות פרטיות זו, אשר בין מטרותיו לעדכן את המשתמש באשר
          למבצעים ו/או שירותים המוצעים על ידי החברה, מי מטעמה ו/או על ידי צדדים
          שלישיים עימם יש למפעילת האתר ו/או חברה שיתוף פעולה עסקי.
        </li>

        <li className={classes.content}>
          המשתמש מצהיר ומתחייב בזאת, כי כל המידע שימסור ו/או יעדכן באתר, הינו
          נכון, אמין ומדויק וכן, כי מסר את המידע בשמו ועבור עצמו בלבד ולא בשם
          ו/או עבור צדדים שלישיים, למעט במקרים בהם הורשה לעשות כן, במפורש. המידע
          שמסר המשתמש וכן מידע נוסף שיצטבר אודותיו ופעולותיו באמצעות האתר ישמרו
          במאגר המידע של החברה, המפורט לעיל, ויעשה בו שימוש בהתאם למטרות המאגר
          המפורטות המדיניות זו ו/או בהתאם להוראות כל דין.
        </li>

        <li className={classes.content}>
          <b>איסוף ושימוש במידע</b>– מפעילת האתר ו/או החברה רשאיות לאסוף וכן
          לעשות שימוש במידע שנמסר על ידי המשתמש במועד ההרשמה, ביצירת קשר עם
          החברה ו/או מפעילת האתר, במידע אשר הצטבר אודות המשתמש, לרבות במהלך
          השימוש באתר, ולרבות סוגי המידע שלהלן:{" "}
          <b>מידע טכני ומזהים דיגיטליים</b>, לרבות סוג הדפדפן, פרטים אודות מכשיר
          הקצה, כתובת IP, נתוני גלישה והרגלי השימוש באתר. מידע זה ייאסף, בין
          היתר, באמצעות Cookies וקבצי מעקב אחרים, כמפורט להלן;{" "}
          <b>הרשמה לאתר ו/או לשירותים ורכישה באמצעות האתר</b> - בעת ההרשמה לאתר
          ו/או השירותים, ובמסגרת רכישת מוצרים באתר, מפעילת האתר ו/או החברה
          עשויות לאסוף ולשמור נתונים אישיים אודות המשתמש אשר הוא נדרש למסור
          לצורך קבלת השירותים, ובכלל זה: שמו המלא, מספר טלפון, כתובת ודוא"ל.
          החברה עשויה לבקש מהמשתמש מידע נוסף מעת לעת; <b>יצירת קשר עם החברה</b>{" "}
          - מפעילת האתר ו/או החברה עשויות לאסוף ולשמור מידע אודות המשתמש בעת
          פנייה של המשתמש לחברה באמצעות טופס "יצירת קשר" באתר, ולרבות שם, כתובת
          דוא"ל, ומידע אחר אודות המשתמש שיספק מרצונו החופשי.
        </li>

        <li className={classes.content}>
          <b>מטרת האיסוף</b> - מפעילת האתר ו/או החברה רשאיות להשתמש במידע שנאסף
          אודותיך על מנת: (א) לשפר, להעשיר או לשנות (לרבות שינוי של האתר המוצג
          למשתמש) את האתר, את השירותים והתכנים המוצעים באתר, (ב) לעדכן את המשתמש
          באשר למבצעים ו/או שירותים המוצעים על ידי החברה, מי מטעמה ו/או על ידי
          צדדים שלישיים עימם יש לחברה שיתוף פעולה עסקי, ו-(ג) לאבטח את המידע
          באתר, ובין היתר, על מנת למנוע הונאות, תפעול, אבטחה, גילוי תרמיות ו/או
          כל פעילות בלתי חוקית אחרת.
        </li>

        <li className={classes.content}>
          בנוסף, רשאית החברה לעשות שימוש במידע למטרות שיווק פרסום ודיוור ישיר
          שלנו או מי מטעמנו, וכן מידע על מוצרים ושירותים של צדדים שלישיים
          שמסופקים בשיתוף פעולה איתנו, לרבות פרסום מותאם אישית.
        </li>

        <li className={classes.content}>
          כמו כן, רשאיות מפעילת האתר ו/או החברה לעשות שימוש במידע שנתקבל מאת
          המשתמש ו/או במידע שנאסף אודותיו, גם במקרים הבאים: לשם יצירת קשר עם
          המשתמש במקרה הצורך; לצורך תחזוקת האתר ו/או המערכת; לצורך שיפור המידע
          והתכנים שהחברה תציע במסגרת האתר למשתמשים באופן אישי ו/או לכלל ו/או
          לחלק מן המשתמשים באתר.
        </li>

        <li className={classes.content}>
          מבלי לגרוע מהאמור לעיל, בכפוף למסירת המשתמש את פרטי ההתקשרות שלו לחברה
          והסכמתו לקבלת דיוור ישיר, תהיה החברה רשאית לשלוח למשתמש, מעת לעת,
          בדואר אלקטרוני, SMS ו/או באמצעי התקשרות אחרים שמסר המשתמש, מידע בדבר
          שירותיהן וכן מידע שיווקי ופרסומי של החברה. המשתמש יהיה רשאי לבטל בכל
          עת את הסכמתו ולחדול מקבלת המידע כאמור בשליחת הודעה לדוא"ל ______או
          באמצעות לחצן "הסרה" אשר יופיע בתחתית ההודעה;
        </li>

        <li className={classes.content}>
          האתר משתמש בעוגיות (Cookies, <b>עוגיות</b>) לצורך תפעולו השוטף והתקין,
          ובכלל זה כדי לאסוף נתונים סטטיסטיים אודות השימוש באתר, לאימות פרטים,
          כדי להתאים את האתר להעדפות האישיות של המשתמש, לאפיין את המוצרים
          המתאימים לו ולצרכי אבטחת מידע. עוגיות הן קבצי טקסט, שהדפדפן של המשתמש
          יוצר לפי פקודה ממחשבי החברה. חלק מהעוגיות יפקעו כאשר תסגור את הדפדפן
          ואחרות נשמרות על גבי הכונן הקשיח במחשב שלך. העוגיות מכילים מידע מגוון
          כדוגמת הדפים שבהם ביקרת, משך הזמן ששהית באתר, מהיכן הגעת אל האתר,
          מדורים ומידע שהמשתמש מבקש לראות בעת הכניסה לאתר ועוד. כמו כן יכול
          והעוגיות ישמרו אף מידע בדבר הרגלי הגלישה של הגולש באתרים אחרים, לרבות
          האתרים בהם גלש, העמודים באתרים וכל פעולה אחרת בהם. המידע בעוגיות
          מוצפן, והחברה נוקטת צעדי זהירות כדי להבטיח שרק מחשבי החברה או מי מטעמה
          יוכלו לקרוא ולהבין את המידע האגור בהם. אם אינך רוצה לקבל עוגיות, תוכל
          להימנע מכך על ידי שינוי ההגדרות בדפדפן שלך. לשם כך נא היוועץ בקובץ
          העזרה של הדפדפן. זכור, עם זאת, שנטרול העוגיות עלול לגרום לכך שלא תוכל
          להשתמש בחלק מהשירותים והתכונות באתר.
        </li>

        <li className={classes.content}>
          <b>מסירת מידע לצד שלישי</b> - מפעילת האתר והחברה תנקוט באמצעים סבירים
          ומקובלים על מנת לשמור ולמנוע העברת פרטים אישיים המזהים את המשתמש,
          לצדדים שלישיים, וזאת למעט במקרים כדלקמן: על פי דרישת המשתמש ו/או
          בהסכמתו המפורשת; לצורך העברתם לספקים של מפעילת האתר או החברה, כגון
          ספקים וחברות שליחויות וזאת לצורך מתן השירותים, ובכלל זה על מנת להשלים
          את פעולת הרכישה שביצע המשתמש באתר; בכל מקרה בו הפר המשתמש את תנאי
          השימוש, לרבות תנאי מדיניות הפרטיות ו/או במקרים בהם בצע המשתמש או ניסה
          לבצע המשתמש ו/או מי מטעמו, באמצעות האתר ו/או בקשר איתו, פעולות
          המנוגדות להוראות תנאי השימוש, לרבות מדיניות הפרטיות, לרבות הוראות כל
          דין; בשל צו שיפוטי המורה לחברה למסור את המידע לצדדים שלישיים; בשל כל
          מחלוקת, טענה, תביעה, דרישה ו/או הליכים משפטיים אשר יתנהלו בין המשתמש
          ו/או מטעמו לבין החברה ו/או מי מטעמה; בכל מקרה כי מסירת המידע נחוצה על
          מנת למנוע נזק חמור לרכושם ו/או לגופם של מפעילת האתר, החברה, המשתמש
          ו/או של צדדים שלישיים, או על מנת למנוע נזק חמור אחר לפי שיקול דעתן
          הבלעדי; במקרה בו מפעילת האתר או החברה העבירו או המחו לצד שלישי
          פעילותן, זכויותיהן או חובותיהן כלפי המשתמש, לצדדים שלישיים, ובלבד
          שצדדים שלישיים כאמור יקבלו על עצמם את ההוראות המפורטות במדיניות פרטיות
          זו.
        </li>

        <li className={classes.content}>
          אין באמור לעיל בכדי לגרוע מזכות מפעילת האתר או החברה להעביר לצדדים
          שלישים מידע שאינו אישי, אשר אין בו בכדי לזהות את המשתמש בשמו ו/או
          בפרטי זהותו באופן ישיר, ולרבות אך לא רק, מידע אגרגטיבי לצרכי מחקר
          וסטטיסטיקה.
        </li>

        <li className={classes.content}>
          כמו כן, מפעילת האתר או החברה רשאיות להשתמש בשירותיהם של ספקי צד ג' על
          מנת לאסוף, לאחסן ו/או לעבד את המידע שנאסף כמפורט לעיל לצורך מתן
          השירותים, וספקים אלה יחויבו לעמוד בהוראות הדין החלות ביחס לעיבוד מידע.
        </li>

        <li className={classes.content}>
          <b>אבטחת מידע</b> - מפעילת האתר והחברה עושות ככל שיכולתן בכדי להגן על
          סודיות הנתונים שנמסרו על ידי משתמשי האתר, זאת תוך נקיטת אמצעי זהירות
          מקובלים ושימוש בטכנולוגיות אבטחה מתקדמות. ידוע למשתמש כי ננקטו אמצעים
          מחמירים למניעת חדירה לאתר ולסיכול פגיעה אפשרית בפרטיות המשתמש, אולם
          היא אינה יכולה למנוע שיבושים באתר באופן מוחלט.
        </li>

        <li className={classes.content}>
          החברה תשתמש באמצעי הגנה והצפנה מסוג SSL, הנהוגים בתחום הסחר האלקטרוני
          בישראל ובארה"ב לפעולות של מסירת מידע מקוון, ובהתאם לנדרש על פי כל דין.
          אמצעי ההגנה האמור נועדו לאבטחת זרימת מידע מוצפנת בין מחשב המשתמש בזמן
          ביצוע הרכישה לבין שרתי האתר והחברה.
        </li>

        <li className={classes.content}>
          מפעילת האתר עושה כל שביכולתה ונעזרת באמצעי אבטחה טכנולוגיים וארגוניים
          מתקדמים כדי לאבטח את האתר, את התקשורת דרכו ואת המידע המצוי בשליטתה,
          כנגד ניצול מקרי או מכוון, אובדן, הרס או כנגד גישה על ידי אנשים בלתי
          מוסמכים או מורשים. ההתקשרות בין המחשב של המשתמש או המבקר באתר לבין
          מחשבי החברה מאובטחת באמצעות שיטות הצפנה מקובלות, בהתאם לתקנים הנהוגים.
          כמו כן, מפעילת האתר נוקטת באמצעים סבירים להגנה על האתר ועל רכיבי חומרה
          ותוכנה הקשורים בתפעולו ודואגת לעדכנם באופן שוטף, בין היתר, כדי להגן על
          האתר ועל תוכנו מפני חדירות, פרצות או האזנות בלתי מורשות. עם זאת מפעילת
          האתר מבהירה, כי במקרים שאינם בשליטתה ו/או נובעים מכח עליון, היא איננה
          מתחייבת, שהאתר יתנהל כסדרו, ללא כל הפרעה, ו/או שהאתר ו/או הנתונים
          שנאספו ו/או נמסרו כאמור לעיל יהיו חסינים באופן מוחלט מפני גישה ו/או
          חדירה בלתי מורשית למאגרי המידע של החברה או מפעילת האתר וכי ידוע למשתמש
          שמפעילת האתר או החברה לא תישאנה באחריות בגין כל נזק ו/או אובדן, ישירים
          או עקיפים, מכל סוג שהוא, שנגרמו כתוצאה מכך, לרבות בשל פגיעה בפרטיות.
        </li>

        <li className={classes.content}>
          כל נושא השימוש וסליקת כרטיסי האשראי מהאתר נעשית באופן מוצפן ומאובטח
          באמצעות חברת סליקת אשראי חיצונית, העושה שימוש בשיטות הצפנה חדישות ועל
          ידי מנגנוני הצפנה שהינם בהתאם לתקנים בינלאומיים.
        </li>

        <li className={classes.content}>
          <b>יצירת קשר בנושא פרטיות</b> - הינך, או מי מטעמך, רשאי לעיין במידע
          אודותיך אשר מצוי במאגר החברה ואף לבקש לתקן מידע זה אם אינו נכון, שלם
          או מדויק. כדי לממש זכות זו, יש לשלוח בקשה באמצעות עמוד "צור קשר" באתר.
        </li>

        <li className={classes.content}>
          בכל שאלה, הבהרה או תגובה בנוגע למדיניות פרטיות זו, או אם ברצונך למחוק,
          לשנות או לתקן את המידע האישי שלך, אנא תפנו אלינו באמצעות [צור קשר].
           בכל תכתובת לחברה יש לכלול את פרטיך המלאים לרבות, כתובת ואי מייל
          ליצירת קשר. נשתדל להגיב לכל בקשה סבירה בזמן סביר.
        </li>

        <li className={classes.content}>
          ככל שיופיעו באתר קישורים לאתרים אחרים, ישראלים או זרים. החברה ו/או
          מפעילת האתר לא תישאנה בכל אחריות לתוכנם של אותם אתרים ולכל מידע
          המתפרסם בהם. הימצאות הקישור באתר <b>אינה</b> מהווה המלצה לבקר בו
          וביקור בו על-ידי הלקוח יהא על פי שיקול דעתו העצמאי.
        </li>
      </ol>
    </div>
  );
};
